export const validateEmail = (email: string): boolean => {
  if (!email.trim()) return false

  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/

  const [, domain] = email.split('@')
  if (domain && (domain.startsWith('.') || domain.endsWith('.') || domain.includes('..'))) {
    return false
  }

  return emailRegex.test(email)
}

export const validatePhone = (phone: string): boolean => {
  const phoneRegex = /^[0-9]{9}$/
  return phone.trim().length > 0 && phoneRegex.test(phone)
}

export interface ValidationError {
  email?: string
  phone?: string
  submit?: string
}

export const getValidationErrors = (
  type: 'email' | 'phone',
  value: string,
  isValid: boolean,
  isRequired: boolean
): string => {
  if (!value.trim() && isRequired) {
    return type === 'email' ? 'El email es requerido' : 'El teléfono es requerido'
  }

  if (!isValid && value.trim()) {
    return type === 'email' ? 'El email no es válido' : 'El teléfono debe tener 9 dígitos'
  }

  return ''
}
